import React from 'react';

import { Grid, Typography } from '@material-ui/core';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';

import ep3collage1 from '../../assets/ep3collage1.jpg';
import ep3collage2 from '../../assets/ep3collage2.jpg';
import ep3collage3 from '../../assets/ep3collage3.jpg';
import ep3collage4 from '../../assets/ep3collage4.jpg';
import ep3collage5 from '../../assets/ep3collage5.jpg';
import ep3collage6 from '../../assets/ep3collage6.jpg';

const useStyles = makeStyles((theme) => ({
  wrapper: {
    paddingTop: '4rem',
    // paddingBottom: '5rem',
    [theme.breakpoints.down('md')]: {
      backgroundColor: theme.palette.common.background,
      marginTop: 0
    }
  },
  textCont: {
    width: '54%',
    [theme.breakpoints.down('sm')]: {
      width: '72.5%'
    }
  },
  subhead1Cont: {
    marginBottom: '.875rem'
  },
  photoRow: {
    marginTop: '1.8rem',
    [theme.breakpoints.down('sm')]: {
      marginTop: '0px'
    }
  },
  photoCollageCont: {
    width: '81%',
    marginTop: '2rem'
  },
  firstPhoto: {
    width: '48%',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      marginTop: '1rem'
    }
  },
  secondPhoto: {
    marginLeft: '1.8rem',
    width: '48%',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      marginLeft: 0,
      marginTop: '1rem'
    }
  },
  // ------------------------------------
  subhead1: {
    ...theme.typography.subhead1,
    textTransform: 'uppercase',
    color: theme.palette.common.green,
    textAlign: 'center',
    [theme.breakpoints.down('sm')]: {
      ...theme.typography.mobile.subhead1
    }
  }
}));

const CollageSection = () => {
  const classes = useStyles();
  const theme = useTheme();
  const matchesSM = useMediaQuery(theme.breakpoints.down('sm'));
  return (
    <Grid container justifyContent="center" className={classes.wrapper}>
      <Grid container justifyContent="center" className={classes.textCont}>
        <Grid item className={classes.subhead1Cont}>
          <Typography className={classes.subhead1}>Zakia McKensey</Typography>
        </Grid>
        <Grid item>
          <Typography variant={matchesSM ? 'body2' : 'body1'} style={{ textAlign: 'center' }}>
            For this activist, making change means wearing many hats. Whether she’s taking the
            testing to the streets in a custom RV or fighting for political change in city hall,
            Zakia McKensey never loses sight of her purpose.
          </Typography>
        </Grid>
      </Grid>
      <Grid container className={classes.photoCollageCont}>
        <Grid container direction={matchesSM ? 'column' : undefined} className={classes.photoRow}>
          <Grid item className={classes.firstPhoto}>
            <img src={ep3collage1} alt="black man" style={{ width: '100%' }} />
          </Grid>
          <Grid item className={classes.secondPhoto}>
            <img src={ep3collage2} alt="black man" style={{ width: '100%' }} />
          </Grid>
        </Grid>
        <Grid container className={classes.photoRow}>
          <Grid item className={classes.firstPhoto}>
            <img src={ep3collage3} alt="black man" style={{ width: '100%' }} />
          </Grid>
          <Grid item className={classes.secondPhoto}>
            <img src={ep3collage4} alt="black man" style={{ width: '100%' }} />
          </Grid>
        </Grid>
        <Grid container className={classes.photoRow}>
          <Grid item className={classes.firstPhoto}>
            <img src={ep3collage5} alt="black man" style={{ width: '100%' }} />
          </Grid>
          <Grid item className={classes.secondPhoto}>
            <img src={ep3collage6} alt="black man" style={{ width: '100%' }} />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default CollageSection;
